//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.DisplayResolutionBuilder.js";
import "../Validate/Validate.SelectionAndPlacementBuilder.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
let d=[[[1,"BuildPlateTemperature",0,"Expression",0],[1,"BuildPlateThickness",0,"Expression",0],[0,"CheckerCreationTime",1,0],[1,"CriticalAngle",0,"Expression",0],[1,"DisplayResolutionBuilder",0,"GeometricUtilities.DisplayResolutionBuilder",0],[1,"ElementSize",0,"Expression",0],[0,"FilePathKey",1,0],[0,"JobID",1,0],[0,"JobStatus",1,0],[1,"LayerThickness",0,"Expression",0],[0,"MaterialEnum",1,0],[1,"NumberOfLasers",0,"Expression",0],[0,"PartMaterial",1,0],[1,"PrinterDiameter",0,"Expression",0],[1,"PrinterHeight",0,"Expression",0],[1,"PrinterLength",0,"Expression",0],[0,"PrinterName",1,0],[0,"PrinterShape",1,0],[1,"PrinterWidth",0,"Expression",0],[1,"SelectionAndPlacement",0,"Validate.SelectionAndPlacementBuilder",0],[0,"StressRelief",1,0],[0,"UserID",1,0]],[[[],"Update",{},0,0],[[],"CheckJobStatus",{},0,0],[[],"CreatePrintCsys",{},0,0],[[],"OrientPartToMinimumThermalDistortion",{},0,0]],[]];
SPLM.Validate.CheckThermalDistortionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.CheckThermalDistortionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.CheckThermalDistortionBuilder.PrinterShapeTypes = Object.freeze({
    "Block" : "Block", "Cylinder" : "Cylinder"});

SPLM.Validate.CheckThermalDistortionBuilder.JobStatusType = Object.freeze({
    "Queued" : "Queued", "Processing" : "Processing", "Completed" : "Completed", "Error" : "Error", "Unknown" : "Unknown"});

export default SPLM;